import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../layout/Layout';
import ServiceLayout from '../components/ServiceLayout';

export default function MobileApplication() {
  return (
    <Layout>
      <ServiceLayout
        title="Mobile Application"
        banner="/assets/images/banner/MobileApp.jpg"
        current="/mobile-application"
      >
        <div className="space-y-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-brand-dark mb-4">Mobile Application</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Transforming ideas into interactive reality, our mobile applications redefine user experiences with seamless design and innovative functionality. Elevate your digital presence and engage your audience with our bespoke mobile solutions. With Android Studio, powered by Java and Kotlin, we create native Android applications that are robust, efficient, and tailored to the Android ecosystem. In the realm of iOS, we use Xcode and Swift to create attractive native apps for the iPhone, iPad, and Apple Watch. For cross-platform development, we offer expertise in React Native and Flutter.
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 list-none p-0">
              {['Intuitive Interface', 'On-the-Go Access'].map((item) => (
                <li key={item} className="flex items-center gap-3 text-brand-dark/80 text-sm">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand/10 flex items-center justify-center">
                    <span className="icon-check-circle text-brand text-xs"></span>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <img src="mobileapp.jpg" alt="#" className="w-full rounded-2xl shadow-md" />

          <div>
            <p className="text-gray-600 leading-relaxed mb-6">
              We understand that one size does not fit all. That's why our mobile applications are designed to be highly customizable, allowing you to tailor them to your unique preferences and requirements.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                { icon: 'icon-web-design', title: 'Innovative Features, Seamless Integration', desc: 'Our skilled developers push boundaries, offering cutting-edge features and seamless integration for intuitive user experiences.' },
                { icon: 'icon-data', title: 'Simplicity Meets Sophistication', desc: 'We prioritize simplicity and usability for enhanced user experiences. With intuitive interfaces and robust performance, our apps seamlessly integrate into your life.' },
              ].map(({ icon, title, desc }) => (
                <div key={title} className="flex items-start gap-4 bg-gray-50 rounded-xl p-5 border border-gray-100">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-brand flex items-center justify-center">
                    <span className={`${icon} text-white text-xl`}></span>
                  </div>
                  <div>
                    <h3 className="text-brand-dark font-bold font-heading mb-2">{title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="flex-1">
              <p className="text-gray-600 leading-relaxed">
                Your privacy is our top priority. We adhere to the strictest standards of data security and encryption to ensure that your personal information remains safe and secure.
              </p>
            </div>
            <div className="flex-shrink-0 md:w-48">
              <img src="/assets/images/services/img2.png" alt="#" className="w-full rounded-xl shadow-sm" />
            </div>
          </div>
        </div>
      </ServiceLayout>
    </Layout>
  );
}
